import { baseApi } from 'services/api';
import { API_VERSION } from 'constants/common';
import { GetPayRunMemberHistoryResponse } from './memberHistory.model';

const PayRunMemberHistoryBaseApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getPayRunMemberHistory: builder.query<
      GetPayRunMemberHistoryResponse,
      { teamId: number; payRunId: string; merchantId: string }
    >({
      query: ({ teamId, payRunId, merchantId }) => ({
        url: `${API_VERSION.V1}/team/${teamId}/pay-run/${payRunId}/member/${merchantId}/history`,
        method: 'GET'
      }),
      providesTags: ['MemberPayRunHistory'],
      extraOptions: {
        failure: 'Failed to fetch member pay run history',
        showToast: true
      }
    })
  })
});

export const { useLazyGetPayRunMemberHistoryQuery } = PayRunMemberHistoryBaseApi;
